import { render, staticRenderFns } from "./addRound.vue?vue&type=template&id=fdaf4a3a&scoped=true&"
import script from "./addRound.vue?vue&type=script&lang=ts&"
export * from "./addRound.vue?vue&type=script&lang=ts&"
import style0 from "./addRound.vue?vue&type=style&index=0&id=fdaf4a3a&lang=scss&scoped=true&"
import style1 from "./addRound.vue?vue&type=style&index=1&id=fdaf4a3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdaf4a3a",
  null
  
)

export default component.exports